<nav class="navbar navbar-expand">
    <div class="container">
        <a
            class="navbar-brand col-md-2 col-sm-1 col-2"
            kno2NoOpLink
            (click)="goHome()">
            <div class="nav-logo"></div>
        </a>

        <kno2-loading-indicator class="d-flex mb-5" />

        <div class="nav-no-collapse header-nav">
            <ul class="navbar-nav me-auto mt-2 mt-lg-0 nav">
                @if (currentUser()?.organizations?.length > 1) {
                    <kno2-org-switcher
                        [organizations]="currentUser().organizations"
                        [organizationName]="currentUser().organizationName" />
                }

                <li
                    id="notifications-shortcut"
                    *kno2ShowForRoleIn="['Administrator', 'User']"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Notifications">
                    <a
                        routerLink="/account/notifications"
                        class="btn"
                        aria-label="Notifications">
                        <i class="fa fa-bell"></i>
                    </a>
                </li>

                <li
                    id="connect-menu"
                    *kno2ShowForRoleIn="['Administrator', 'User']"
                    class="dropdown"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Connect with Others">
                    <a
                        class="btn dropdown-toggle"
                        data-bs-toggle="dropdown"
                        role="button"
                        aria-label="Connect with Others">
                        <i class="fa fa-envelope"></i>
                    </a>
                    <ul class="dropdown-menu">
                        <li
                            role="presentation"
                            class="dropdown-header">
                            Connect with Others
                        </li>
                        <li>
                            <a
                                kno2NoOpLink
                                (click)="openInvitationModal()">
                                <i
                                    class="fa fa-envelope"
                                    aria-hidden="true"></i>
                                Send an Invite
                            </a>
                        </li>
                    </ul>
                </li>

                <li
                    id="users-shortcut"
                    *kno2ShowForRoleIn="['SysAdmin']"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Users">
                    <a
                        class="btn"
                        routerLink="/admin/users">
                        <i class="fa fa-user"></i>
                    </a>
                </li>
                <li
                    id="organizations-shortcut"
                    *kno2ShowForRoleIn="['SysAdmin']"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Organizations">
                    <a
                        class="btn"
                        routerLink="/admin/organizations">
                        <i class="fa fa-globe"></i>
                    </a>
                </li>

                <!-- Support Menu -->
                <li
                    id="support-menu"
                    *kno2ShowForRoleIn="['Administrator', 'User']"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Support Center">
                    <a
                        class="btn dropdown-toggle"
                        routerLink="/supportcenter"
                        aria-label="Support Center">
                        <i class="fa fa-question-circle"></i>
                    </a>
                </li>

                <kno2-settings-menu
                    *kno2ShowForRoleIn="['Administrator']"
                    [currentUser]="currentUser()" />
                <kno2-profile-menu
                    [currentUser]="currentUser()"
                    (onProfileUpdated)="updateProfile()" />
            </ul>
        </div>
    </div>
</nav>
